export default "__VITE_ASSET__DpS67U3I__"